import React from 'react';

/**
 * Rysunek kafelka „Sprawdź kompatybilność magazynu z falownikiem” na stronie
 * głównej, w stylu rysunku oferty (GrafikaOferta.jsx): urządzenia w firmowym
 * niebieskim, zielony znaczek na połączeniu. BEZ białych kart pod urządzeniami:
 * na jasnym tle kafelka wyglądały jak niedokończone (uwaga właściciela 2026-10-01).
 *
 * Osobny od `CompatibilityAnimation`: tamta pokazuje na stronie kompatybilności
 * WYNIK sprawdzenia (cztery stany sterowane odpowiedzią API), a ta jest tylko
 * zapowiedzią narzędzia na kafelku. Zmiana wyglądu strony głównej nie może
 * ruszać ekranu wyników.
 *
 * Ruch: energia płynie kablem, a ogniwa magazynu zapalają się od dołu. Oba
 * zatrzymują się przy ograniczonym ruchu (index.css).
 * Kolory na sztywno, jak w rysunku oferty.
 */

const NIEB = '#2563eb';
const NIEB_TLO = '#dbeafe';
const ZIELONY = '#10b981';
const KABEL = 'M60 55C80 42 120 68 141 55';

const GrafikaKompatybilnosc = ({ className = '' }) => (
  <div className={className} aria-hidden="true">
    <svg viewBox="16 18 168 68" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
      {/* ── Kabel z płynącą energią ── */}
      <path d={KABEL} fill="none" stroke="#bfdbfe" strokeWidth="3" strokeLinecap="round" />
      <path className="vv-przeplyw" d={KABEL} fill="none" stroke={NIEB} strokeWidth="3"
            strokeLinecap="round" strokeDasharray="2 5" />

      {/* ── Falownik ── */}
      <rect x="24" y="27" width="36" height="52" rx="8" fill={NIEB_TLO} stroke={NIEB} strokeWidth="2.2" />
      <rect x="31" y="34" width="22" height="11" rx="3" fill="#ffffff" stroke={NIEB} strokeWidth="1.5" />
      <path d="M33 62c2.7 -6.2 6.3 -6.2 9 0s6.3 6.2 9 0" fill="none" stroke={NIEB}
            strokeWidth="2.2" strokeLinecap="round" />
      <circle cx="53" cy="71" r="2" fill={ZIELONY} />

      {/* ── Magazyn: ogniwa zapalają się od dołu ── */}
      <rect x="152" y="24" width="12" height="5" rx="1.5" fill={NIEB} />
      <rect x="141" y="28" width="34" height="52" rx="7" fill={NIEB_TLO} stroke={NIEB} strokeWidth="2.2" />
      <rect className="vv-ogniwo" style={{ animationDelay: '0.8s' }} x="147" y="34" width="22" height="10" rx="2.5" fill={ZIELONY} />
      <rect className="vv-ogniwo" style={{ animationDelay: '0.4s' }} x="147" y="47" width="22" height="10" rx="2.5" fill={ZIELONY} />
      <rect className="vv-ogniwo" x="147" y="60" width="22" height="10" rx="2.5" fill={ZIELONY} />

      {/* ── Wtyki i znaczek zgodności na środku kabla ── */}
      <circle cx="60" cy="55" r="3.5" fill={NIEB} stroke="#ffffff" strokeWidth="1.5" />
      <circle cx="141" cy="55" r="3.5" fill={NIEB} stroke="#ffffff" strokeWidth="1.5" />
      <g className="vv-oferta-wpis" style={{ animationDelay: '0.3s' }}>
        <circle cx="100" cy="55" r="12" fill={ZIELONY} stroke="#ffffff" strokeWidth="3.5" />
        <path d="M94.5 55.5l4 4 7.5 -8" fill="none" stroke="#ffffff" strokeWidth="2.8"
              strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  </div>
);

export default GrafikaKompatybilnosc;
